// Tiny class-name joiner (no dependency needed).
const cn = (...parts) =>
  parts
    .flat()
    .filter((part) => typeof part === "string" && part.trim().length > 0)
    .join(" ");

export default cn;
